import AppSidebar from "@/components/sidebar/AppSidebar";
import Navbar, { NavbarProvider } from "@/components/navbar";
import FloatingGettingStarted from "@/components/onboarding/FloatingGettingStarted";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { useWorkoutSession } from "@/lib/states/workout/hooks";
import { publish, TrainrrEvents } from "@/lib/utils/events";
import {
  Outlet,
  createFileRoute,
  useNavigate,
  useRouterState,
} from "@tanstack/react-router";
import { Play } from "lucide-react";
import { VersionHistoryHost } from "@/components/planHistory/VersionHistoryHost";
import { TasksSheet } from "@/components/tasks/TasksSheet";

export const Route = createFileRoute("/_auth/_dashboard")({
  component: DashboardLayout,
});

function DashboardLayout() {
  const navigate = useNavigate();
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });
  const isUpgradeRoute = pathname === "/upgrade";
  const { activeWorkoutData, setMinimized } = useWorkoutSession();
  const showResume = Boolean(activeWorkoutData?.clientId);

  const handleResumeWorkout = () => {
    if (!activeWorkoutData?.clientId) return;
    setMinimized(false);
    navigate({
      to: "/workout-session",
    });
  };

  return (
    <NavbarProvider>
      {isUpgradeRoute ? (
        <main
          id="main-scrollable-area"
          className="relative h-svh w-full overflow-y-auto overscroll-contain bg-background"
          onScroll={(e) => {
            publish(TrainrrEvents.MainScrollEvent, e);
          }}
        >
          <Outlet />
        </main>
      ) : (
        <SidebarProvider className="h-svh overflow-hidden">
          <AppSidebar variant="inset" />
          <SidebarInset className="!min-h-0 h-svh overflow-hidden md:h-[calc(100svh-theme(spacing.4))]">
            <Navbar />
            <TasksSheet />
            <FloatingGettingStarted />
            <VersionHistoryHost>
              <main
                id="main-scrollable-area"
                className="relative min-h-0 flex-1 w-full min-w-0 overflow-y-auto overscroll-contain"
                onScroll={(e) => {
                  publish(TrainrrEvents.MainScrollEvent, e);
                }}
              >
                <Outlet />
              </main>
            </VersionHistoryHost>
            {showResume && (
              <Button
                size="lg"
                onClick={handleResumeWorkout}
                className="fixed bottom-6 right-6 z-40 rounded-2xl bg-primary px-4 py-3 text-base font-semibold uppercase tracking-wide text-primary-foreground shadow-[0_18px_40px_rgba(37,99,235,0.35)] hover:bg-primary/90"
              >
                <span className="mr-3 inline-flex size-6 items-center justify-center rounded-full bg-white text-primary">
                  <Play className="ml-0.5 size-2 fill-current" />
                </span>
                Resume workout
              </Button>
            )}
          </SidebarInset>
        </SidebarProvider>
      )}
    </NavbarProvider>
  );
}
